import { useMemo } from 'react';
import { htcmdService } from 'js/services/htcmd.service';

export const useHTCMDPublicAPI = () => {
    const {
        isEnabled,
        isWrapperEnabled,
        sendMessage,
        portalEvent,
        processBiometricAuthentication,
        login
    } = htcmdService;

    return useMemo(() => ({
        /**
         * Is `true` if Native integration is enabled.
         * @memberOf Playtech.API.htcmd
         * @type Boolean
         * @example
         * // false
         * Playtech.API.htcmd.isEnabled;
         */
        isEnabled,
        /**
         * Is `true` if Wrapper integration is enabled.
         * @memberOf Playtech.API.htcmd
         * @type Boolean
         *  @example
         * // false
         * Playtech.API.htcmd.isWrapperEnabled;
         */
        isWrapperEnabled,
        /**
         * Send command to Native application.
         * @memberOf Playtech.API.htcmd
         * @function
         * @param command {String} Command name.
         * @param options {Object} Plain object with parameters for the command.
         * @example
         * Playtech.API.htcmd.sendMessage('portalEvent', { event: 'depositCompleted', amount: '20', currency: 'USD' });
         */
        sendMessage,
        /**
         * Send portalEvent command to Native application.
         * @memberOf Playtech.API.htcmd
         * @function
         * @param options {Object} Plain object with parameters for the command.
         * @example
         * Playtech.API.htcmd.portalEvent({ event: 'depositCompleted', amount: '20', currency: 'USD' });
         */
        portalEvent,
        /**
         * Send "authentication/processBiometricAuthentication" command to Native application that Biometric Login is available.
         * @memberOf Playtech.API.htcmd
         * @function
         * @example
         * Playtech.API.htcmd.processBiometricAuthentication();
         */
        processBiometricAuthentication,
        /**
         * Send 'loginsuccess' (?isNative=1) / 'login' (?htcmd=1) to Native application with authentication data.
         * @memberOf Playtech.API.htcmd
         * @function
         * @param options {Object} plain object with parameters for the command.
         * @example
         * Playtech.API.htcmd.login({ ...options });
         */
        login
    }), [
        isEnabled,
        isWrapperEnabled,
        sendMessage,
        portalEvent,
        processBiometricAuthentication,
        login
    ]);
};
